export default "__VITE_ASSET__ChRTxpIa__"